import React, { type ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, HStack, Icon, useShareTextDialog } from '@garnish/core';

import { giftCardCheckoutDeliveryMethodMessageCardMessages as messages } from './GiftCardCheckoutDeliveryMethodMessageCard.messages';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardCheckoutDeliveryMethodMessageCard = () => {
  const { canShare } = useShareTextDialog();

  return (
    <View style={styles.messagingAppsCard}>
      {canShare ? (
        <HStack gap={0} style={styles.messagingAppsList}>
          {Object.entries(SOCIAL_NETWORK_ICONS).map(([label, iconName]) => (
            <View
              key={`gift-card-checkout-social-network-wrapper-${iconName}`}
              accessible={true}
              accessibilityRole="image"
              accessibilityLabel={label}
            >
              <View aria-hidden={true}>
                <Icon
                  name={iconName}
                  width={MESSAGING_APPS_ICON_SIZE}
                  height={MESSAGING_APPS_ICON_SIZE}
                />
              </View>
            </View>
          ))}
        </HStack>
      ) : null}

      <BodyText sizeMatch={['12']}>
        {canShare ? (
          <FormattedMessage {...messages.messageOptionHelperTextMessagingApps} />
        ) : (
          <FormattedMessage {...messages.messageOptionHelperText} />
        )}
      </BodyText>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SOCIAL_NETWORK_ICONS = {
  WhatsApp: 'IconWhatsapp',
  Messenger: 'IconMessenger',
  Telegram: 'IconTelegram',
  Message: 'IconMessage',
  Instagram: 'IconInstagram',
} satisfies Record<string, IconName>;

const MESSAGING_APPS_ICON_SIZE = 24;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  messagingAppsCard: {
    backgroundColor: theme.colors.OPACITY.KALE.LIGHTEST,
    borderRadius: theme.radius.large,
    marginTop: theme.spacing['4'],
    padding: theme.spacing['4'],
  },
  messagingAppsList: {
    marginBottom: theme.spacing['4'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type IconName = ComponentProps<typeof Icon>['name'];
